import {
  FormattedCurrency,
  FormattedDecimal,
  Panel,
  SectionTitle,
  Table
} from '@elotech/components';
import React from 'react';

import { ParametroItbiAliquota } from '../../../type';

type Props = {
  tipoItbi: string;
  valorReferencia: number;
  tipoAplicacao: string;
  aliquotas: ParametroItbiAliquota[];
};

const AliquotaIntevaloValorTable: React.FC<Props> = ({
  tipoItbi,
  valorReferencia,
  tipoAplicacao,
  aliquotas
}) => {
  aliquotas.sort((a1, a2) => a1.valorFinal - a2.valorFinal);
  return (
    <>
      <SectionTitle>
        ITBI - {tipoItbi.toLocaleUpperCase()} / Alíquotas por{' '}
        {tipoAplicacao.toLocaleUpperCase()}
        <div className={`hint inline module-color fa-question-circle sm clean`}>
          <div className="hint-content">
            {tipoAplicacao.toLocaleUpperCase() === 'INTERVALO' &&
              'Exemplo: Se a faixa 1 for de R$0 a R$ 100.000,00, com alíquota de 1,5% , faixa 2 for de R$ 100.000,01 a R$ 150.000,00, com alíquota de 0,5%, ' +
                ' e o valor de avaliação for R$ 150.000,00, a alíquota de 1,5% será aplicada apenas sobre os primeiros R$ 100.000,00 e a alíquota de 0,5% para os R$ 50.000,00 restantes. ' +
                'Dessa forma, o valor total do ITBI será calculado com base na soma das alíquotas aplicadas a cada faixa de valor. '}
            {tipoAplicacao.toLocaleUpperCase() === 'FAIXA' &&
              'Exemplo: Se a faixa 1 for de R$0 a R$ 100.000,00, com alíquota de 1,5% , faixa 2 for de R$ 100.000,01 a R$ 150.000,00, com alíquota de 0,5%, ' +
                ' e o valor de avaliação for R$ 150.000,00, será aplicado a alíquota de 0,5%. ' +
                'Dessa forma, o valor total do ITBI será calculado com base na alíquota aplicada na faixa valor. '}
          </div>
        </div>
      </SectionTitle>
      <Panel isTable>
        <Table
          values={aliquotas || []}
          keyExtractor={(item, index) => index!}
          highlightError={item => !!item}
          highlightSuccess={item =>
            tipoAplicacao.toLocaleUpperCase() === 'INTERVALO'
              ? +item.valorInicial <= +valorReferencia
              : +item.valorInicial <= +valorReferencia &&
                +valorReferencia <= +item.valorFinal
          }
        >
          <Table.Column<ParametroItbiAliquota>
            name="aliquota"
            header="Alíquota"
            value={item => (
              <>
                <FormattedDecimal
                  minimumFractionDigits={1}
                  value={item.aliquota}
                />{' '}
                {' %'}
              </>
            )}
          />
          <Table.Column<ParametroItbiAliquota>
            name="valorInicial"
            header="Valor inicial"
            value={item => <FormattedCurrency value={item.valorInicial} />}
          />
          <Table.Column<ParametroItbiAliquota>
            name="valorFinal"
            header="Valor final"
            value={item => <FormattedCurrency value={item.valorFinal} />}
          />
        </Table>
      </Panel>
    </>
  );
};

export default AliquotaIntevaloValorTable;
